import { toast } from "react-toastify";
import { topicRepository } from "../../../providers/repositories/topicRepository";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const deleteTopicUseCase = {
    async exec(id: string | number) {
        try {
            await topicRepository.delete(id);
            toast.success(t("action.deleteSuccess"));
            return true;
        } catch (error) {
            toast.error(t("action.deleteError"));
            Logger.error("deleteTopicUseCase", error);
        }
        return false;
    },
};
